import * as React from "react";
import { SilModal } from "./SilModal";

export interface Props {
  onSubmit: () => void;
  onClose: () => void;
  typeName: string;
}

export default class ConfirmDeletingCustomDataSheetModal extends React.Component<Props, {}> {
  render() {
    
    return (
      <SilModal closeModal={this.props.onClose} title="Silsolver" >
        <div>
          <p>Are you sure want to delete {this.props.typeName}?</p>
          <div className="warning-footer ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
            <div className="left-div"></div>
            <div className="buttons">
              <button onClick={this.props.onClose}> Cancel </button>
              <button onClick={this.props.onSubmit}> Delete </button>
            </div>
          </div>
        </div>
      </SilModal>
    );
  }
}